import { Component, ChangeDetectorRef, OnInit, ViewChild } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalConfig,
} from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "../../service/HTTPService/HttpService";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";

import { CustomReportComponent } from "../custom-report/custom-report.component";

import Swal from "sweetalert2";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
@Component({
  selector: "app-actions-cell",
  template: `<i
      class="fa fa-eye"
      style="font-size:20px;color:green"
      (click)="GetEquipmentParameters(configureModal)"
    ></i>

    <ng-template #configureModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Update Custom Report</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="margin-top: -16px;">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label>Saved Report Name</label>
              <input
                type="text"
                class="form-control"
                [disabled]="ifYesDisableIt"
                [(ngModel)]="reportname"
                size="50"
                minlength="50"
                maxlength="50"
                placeholder="Report Name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <label>Report Type</label>
              <select
                class="form-control"
                [(ngModel)]="reporttype"
                style="opacity: 0.5;
                pointer-events: none;"
              >
                <option value="Detailed">Detailed</option>
                <option value="Summary">Summary</option>
              </select>
            </div>

            <div class="form-group">
              <label>Select Equipment Type</label>
              <ng-multiselect-dropdown
                [placeholder]="'Select'"
                [settings]="settingsEquipment"
                [data]="EquipDropdown"
                [(ngModel)]="EquipmentSelecteds"
                (onSelect)="onItemSelectEquipment($event)"
                (onSelectAll)="onSelectAll($event)"
                (onDeSelect)="onDeSelectEquipment($event)"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label id="FirstEquipmentText">{{ FirstEquipmentText }}</label
              ><span id="fstEq" hidden>{{ FstEqpId }}</span>
              <ng-multiselect-dropdown
                [placeholder]="'Select'"
                [settings]="settingss"
                [data]="EquipDropdownsFirst"
                [(ngModel)]="EquipDropdownsFirstSelected"
                *ngIf="FirstEquipmentParam"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="form-group">
              <label>{{ SecondEquipmentText }}</label
              ><span id="secEq" hidden>{{ SecEqpId }}</span>
              <ng-multiselect-dropdown
                [placeholder]="'Select'"
                [settings]="settingss"
                [data]="EquipDropdownsSecond"
                [(ngModel)]="EquipDropdownSecondSelected"
                *ngIf="SecondEquipmentParam"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="form-group">
              <label>{{ ThirdEquipmentText }}</label
              ><span id="ThirdEq" hidden>{{ ThirdSecEqpId }}</span>
              <ng-multiselect-dropdown
                [placeholder]="'Select'"
                [settings]="settingss"
                [data]="EquipDropdownsThird"
                [(ngModel)]="EquipDropdownThirdSelected"
                *ngIf="ThirdEquipmentParam"
              >
              </ng-multiselect-dropdown>
            </div>

            <div class="form-group">
              <label>{{ FourthEquipmentText }}</label
              ><span id="FourthEq" hidden>{{ FourthEqpId }}</span>
              <ng-multiselect-dropdown
                [placeholder]="'Select'"
                [settings]="settingss"
                [data]="EquipDropdownsFourth"
                [(ngModel)]="EquipDropdownFourthSelected"
                *ngIf="FourthEquipmentParam"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div *ngIf="isEditSheduleReport">
          Schedule Report
          <p style="float: right;">
            You want cancel schedule report ?
            <input type="checkbox" (change)="SheduleReportCancel($event)" />
          </p>
          <hr />
          <div class="row">
            <div class="col-sm-4-col-lg-4 col-md-4">
              <div class="form-group">
                <label>Select {{ GetClustorZoneSieName }}</label>
                <ng-select
                  [multiple]="true"
                  [closeOnSelect]="false"
                  name="name"
                  class="custom"
                  [items]="getClustorZone"
                  bindValue="ID"
                  [virtualScroll]="true"
                  bindLabel="Name"
                  placeholder="Select"
                  [(ngModel)]="SelectedClustorZone"
                >
                  <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-item$="item$"
                    let-index="index"
                  >
                    <input
                      id="item-{{ index }}"
                      type="checkbox"
                      name="items-{{ index }}"
                      [(ngModel)]="item$.selected"
                    />
                    {{ item.Name }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <div clas="form-group" style="width: 130%;">
                <label>Select Mail </label>
                <ng-select
                  [multiple]="true"
                  [closeOnSelect]="false"
                  name="getEmailids123"
                  [items]="getEmailCoolingClass"
                  bindValue="EmailID"
                  [virtualScroll]="true"
                  bindLabel="EmailID"
                  placeholder="Select"
                  [(ngModel)]="selectedgetEditEmailClass"
                >
                  <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-item$="item$"
                    let-index="index"
                  >
                    <input
                      id="item-{{ index }}"
                      type="checkbox"
                      name="items-{{ index }}"
                      [(ngModel)]="item$.selected"
                    />
                    {{ item.EmailID }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-lg-12 col-md-12">
              <div class="form-group">
                <label class="form-check-label">Enter Mail</label>
                <div
                  style="
            border: 1px solid #dddddd;
            height: 90px;
            padding: 5px;"
                >
                  <div
                    class="FilterSpan _xl"
                    id="FilterSpan{{ filter.id }}"
                    *ngFor="let filter of filterSearchListEdit"
                  >
                    <span style="font-size: 13px;">{{ filter.value }}</span>
                    <button
                      type="button"
                      class="close"
                      id="FiltercloseBtn"
                      style="padding-left: 5px;
            overflow: hidden !important;
            line-height: 0.5 !important;
            word-wrap: break-word;"
                      (click)="removeFilter1(filter.name)"
                    >
                      <img
                        src="assets/img/close.png"
                        alt="close"
                        height="10"
                        width="10"
                      />
                    </button>
                  </div>

                  <textarea
                    type="email"
                    placeholder="Enter your email"
                    (keyup.enter)="keyUpFunctionEdit($event)"
                    class="form-control"
                    autocomplete="off"
                    [(ngModel)]="validMailIdEdit"
                    name="UpdatevalidmailId"
                    #UpdateSaveScheduleReport
                    id="UpdateSaveScheduleReport"
                    style="position:relative;margin-left:0px;width: 100%;border: 0px;"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
     
        <button
          type="button"
          class="btn btn-primary btn-sm btn-block"
          data-dismiss="modal"
          (click)="GenerateUpdateReport()"
          style="margin-top: 0%;"
        >
          Update
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm btn-block"
          data-dismiss="modal"
          (click)="modal.dismiss('Cross click')"
          style="margin-top: 0%;"
        >
          Cancel
        </button>
      </div>
    </ng-template>

    <ng-template #SampleView let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Report Layout</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ag-grid-angular
          class="ag-theme-alpine"
          [domLayout]="domLayout"
          [columnDefs]="columnDefs"
          [rowData]="rowDatasample"
          [frameworkComponents]="frameworkComponents"
          [pagination]="true"
          [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter"
          enableColResize
          enableSorting
          enableFilter
          groupHeaders
          suppressRowClickSelection
          suppressRowClickSelection
          toolPanelSuppressGroups
          rowSelection="multiple"
          (beforeFilterChanged)="onBeforeFilterChanged()"
          (afterFilterChanged)="onAfterFilterChanged()"
          (filterModified)="onFilterModified()"
          (beforeSortChanged)="onBeforeSortChanged()"
          (afterSortChanged)="onAfterSortChanged()"
          [overlayLoadingTemplate]="loadingTemplate"
          [overlayNoRowsTemplate]="noRowsTemplate"
        >
        </ag-grid-angular>
      </div>
    </ng-template> `,
  styles: [
    `
      .style-3::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
      }
      .style-3::-webkit-scrollbar {
        width: 6px;
        background-color: #f5f5f5;
      }

      .style-3::-webkit-scrollbar-thumb {
        background-color: #999999;
      }
      .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        pointer-events: auto;
        width: 127% !important;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 0.3rem;
        outline: 0;
      }
      .vl {
        border-left: 6px solid green;
        height: 500px;
        position: absolute;
        left: 50%;
        margin-left: -3px;
        top: 0;
      }

      ,
      #sdsdsd {
        height: 120px;
      }
      .form-check {
        position: relative;

        display: initial;
        padding-left: -4.75rem;
        /* margin-left: unset; */
        margin-left: 7px;
      }
      ._xl {
        background: #f4f4f4;
        border: 1px solid #cccccc;
        margin: 0px 5px 0 0;
        font-size: 12px;
        display: block;
        color: #333333;
        word-wrap: break-word;
        float: left;
        padding: 0px 5px 0px 5px;
        margin-bottom: 2px;
        border-radius: 12px;
      }
      .modal-footer button {
        width: 230px;
      }
    `,
  ],
})
export class CustomReportActionComponent
  implements ICellRendererAngularComp, OnInit
{
  selectedoption = "Action";
  closeResult: string;
  public params: any;
  public sid = "";
  openAlarm: any[] = [];
  criticalAlarm: any[] = [];
  majorAlarm: any[] = [];
  minorAlarm: any[] = [];
  alerts: any[] = [];
  dropdownList = [];
  selectedItemss = [];
  public settingss = {};
  EquipDropdown: any;
  EquipDropdowns: any;
  arr_InternalAlertMsg: any[] = [];
  EquipDropdownsFirst: any;
  EquipDropdownsFirstSelected: any[] = [];
  FirstEquipmentParam: boolean = false;
  FirstEquipmentText: any;
  EquipDropdownsSecond: any;
  EquipDropdownSecondSelected: any[] = [];
  SecondEquipmentParam: boolean = false;
  SecondEquipmentText: any;
  EquipDropdownsThird: any;
  EquipDropdownThirdSelected: any[] = [];
  ThirdEquipmentParam: boolean = false;
  ThirdEquipmentText: any;
  EquipDropdownsFourth: any;
  EquipDropdownFourthSelected: any[] = [];
  FourthEquipmentParam: boolean = false;
  FourthEquipmentText: any;
  EquipmentSelected = [];
  reporttype: any;
  rowData: any;
  settingsEquipment: any;
  countVar: number;
  indexValue: any;
  arraIndex: any[] = [];
  reportname: any;
  Equipments: any[] = [];
  RequestJSON1: any;
  EquipmentSelecteds: any = [];
  isEditSheduleReport: boolean = false;
  ifYesDisableIt: boolean = true;
  RepSheduled;
  firstArray: any[] = [];
  SecondArray: any[] = [];
  ThirddArray: any[] = [];
  FourthArray: any[] = [];
  columnDefs = [];
  rowDatasample: any[] = [];
  gridOptions: any;
  isChecked: any;
  checkedValue = 0;
  ScheduleRepAccessability: any;
  ScheduleRepdailySelectedTypeNum: any;
  getClustorZone: any;
  GetClustorZoneSieName: any;
  SelectedClustorZone: any[] = [];
  filterSearchListEdit: any[] = [];

  getEmailCoolingClass: any[];
  selectedgetEditEmailClass;
  getmailIdvaluesEdit: any[] = [];
  unique;
  validMailIdEdit;
  FstEqpId: any;
  SecEqpId: any;
  ThirdSecEqpId: any;
  FourthEqpid: any;
  public domLayout: "normal" | "autoHeight" | "print" = "autoHeight";
  constructor(
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    config: NgbModalConfig,
    private http: HttpService,
    private custmreport: CustomReportComponent,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService
  ) {
    config.backdrop = "static";
    const token = sessionStorage.getItem("invUIToken");
    if (token == null || token == "") {
      window.open("/login", "_self");
    }
  }
  @ViewChild("multiSelect") multiSelect;
  ngOnInit() {
    this.settingss = {
      singleSelection: false,
      idField: "columnid",
      textField: "fieldaliasname",
      enableCheckAll: false,
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      allowSearchFilter: true,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 2,
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: true,
      defaultOpen: false,
    };
    this.settingsEquipment = {
      singleSelection: false,
      idField: "equipmentid",
      textField: "equipmentname",
      enableCheckAll: false,
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      allowSearchFilter: true,
      limitSelection: 4,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 4,
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: true,
      defaultOpen: false,
    };
  }
  reportTypeValue;
  agInit(params: any): void {
    this.params = params;
    this.sid = this.params.data.SiteID;
    this.RepSheduled = this.params.data.IsSchedule;
  }
  refresh(): boolean {
    return false;
  }

  editReportId;
  editReportTimeType;
  editReportType;
  GetEquipmentParameters(Configure) {
    this.getEmailIds();
    this.rowData = this.params;
    this.cdr.detectChanges();
    this.openConfigureModal(Configure);
    this.reporttype = this.rowData.data.reporttypename;
    this.reportname = this.rowData.data.reportname;
    this.reportTypeValue = this.rowData.data.reporttype;
    this.editReportId = this.rowData.data.reportid;
    this.editReportTimeType = this.rowData.data.reporttimetype;
    this.editReportType = this.rowData.data.reporttype;
    this.indexValue = [0, 1, 2, 3];
    this.FirstEquipmentParam = false;
    this.SecondEquipmentParam = false;
    this.ThirdEquipmentParam = false;
    this.FourthEquipmentParam = false;
    this.FirstEquipmentText = "";
    this.SecondEquipmentText = "";
    this.ThirdEquipmentText = "";
    this.FourthEquipmentText = "";
    this.FstEqpId = "";
    this.SecEqpId = "";
    this.FstEqpId = "";
    this.FourthEqpid = "";
    this.getSelectedParameters();
    if (this.RepSheduled == "Yes") {
      this.ifYesDisableIt = true;
    } else {
      this.ifYesDisableIt = false;
    }
    let ClustorZoneUrl = "CustomReports/GetFilterTypeOptions";

  }
  editSelectEquipmentData;
  getSelectedParameters() {
    const reqJson = {
      reporttype: this.editReportType,
      reportid: this.editReportId,
      reporttimetype: this.editReportTimeType,
    };
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.getSavedReportData,
        reqJson
      )
      .subscribe(
        (res) => {
          const resp = res.response;
          this.editSelectEquipmentData = resp;
          this.LoadEquipmentList();
        },
        (error) => {
          console.error(error);
        }
      );
  }
  removeFilter1(filterName) {
    var index = this.filterSearchListEdit.findIndex(function (item) {
      return item.name == filterName;
    });
    if (index > -1) {
      this.filterSearchListEdit.splice(index, 1);
    }
    this.getmailIdvaluesEdit = [];
    for (let x = 0; x <= this.filterSearchListEdit.length - 1; x++) {
      this.getmailIdvaluesEdit.push(this.filterSearchListEdit[x].name);
    }
  }
  validateEmail(email) {
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      )
    ) {
      return false;
    } else {
      return true;
    }
  }
  keyUpFunctionEdit(event) {
    let storeValues: any;
    if (event.keyCode == 13) {
      let storedVal = event.target.value;
      storeValues = storedVal.split("\n");
      for (let i = 0; i <= storeValues.length - 2; i++) {
        this.unique = storeValues.filter(
          (item, i, ar) => ar.indexOf(item) === i
        );
        if (this.validateEmail(storeValues[i])) {
          this.getmailIdvaluesEdit.push(storeValues[i]);

          this.filterSearchListEdit.push({
            name: storeValues[i],
            value: storeValues[i],
          });
          this.validMailIdEdit = "";
        } else {
          Swal.fire({ text: "Enter valid Mail id" });
        }
      }
    }
  }
  async getEmailIds() {
    this.filterSearchListEdit = [];
    this.getmailIdvaluesEdit = [];
    await this.http
      .get(this.urlAuthentication.itocUrl + this.apiUrl.getEmailUrl)
      .subscribe((res) => {
        const getResp: string = JSON.stringify(res);
        const resp = JSON.parse(getResp);
        this.getEmailCoolingClass = resp;
      });
  }

 

  onItemSelectEquipment(event) {
    let ListValue = this.indexValue.reduce((a, b) => Math.min(a, b));
    let dataValue = {
      equipmentId: event.equipmentid,
      reportType: this.reportTypeValue,
    };
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.getEquipmentConfigUrl,
        dataValue
      )
      .subscribe(
        (res) => {
          let EquipDropdowns = res.response;
          if (ListValue == 0) {
            this.FirstEquipmentText = event.equipmentname;
            this.FstEqpId = event.equipmentid;
            this.EquipDropdownsFirst = EquipDropdowns;
            this.FirstEquipmentParam = true;
            for (let n = 0; n < this.indexValue.length; n++) {
              if (this.indexValue[n] == ListValue) {
                delete this.indexValue[n];
              }
            }
          }
          if (ListValue == 1) {
            this.SecondEquipmentText = event.equipmentname;
            this.EquipDropdownsSecond = EquipDropdowns;
            this.SecondEquipmentParam = true;
            this.SecEqpId = event.equipmentid;
            for (let n = 0; n < this.indexValue.length; n++) {
              if (this.indexValue[n] == ListValue) {
                delete this.indexValue[n];
              }
            }
          } else if (ListValue == 2) {
            this.ThirdEquipmentText = event.equipmentname;
            this.EquipDropdownsThird = EquipDropdowns;
            this.ThirdEquipmentParam = true;
            this.ThirdSecEqpId = event.equipmentid;
            for (let n = 0; n < this.indexValue.length; n++) {
              if (this.indexValue[n] == ListValue) {
                delete this.indexValue[n];
              }
            }
          } else if (ListValue == 3) {
            this.FourthEquipmentText = event.equipmentname;
            this.EquipDropdownsFourth = EquipDropdowns;
            this.FourthEquipmentParam = true;
            this.FourthEqpid = event.equipmentid;
            for (let n = 0; n < this.indexValue.length; n++) {
              if (this.indexValue[n] == ListValue) {
                delete this.indexValue[n];
              }
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }
  onDeSelectEquipment(event) {
    if (event.equipmentname == this.FirstEquipmentText) {
      this.EquipDropdownsFirstSelected = [];
      this.FirstEquipmentText = "";
      this.FstEqpId = "";
      this.FirstEquipmentParam = false;
      this.indexValue.push(0);
    } else if (event.equipmentname == this.SecondEquipmentText) {
      this.EquipDropdownSecondSelected = [];
      this.SecondEquipmentParam = false;
      this.SecondEquipmentText = "";
      this.SecEqpId = "";
      this.indexValue.push(1);
    } else if (event.equipmentname == this.ThirdEquipmentText) {
      this.EquipDropdownThirdSelected = [];
      this.ThirdEquipmentParam = false;
      this.ThirdEquipmentText = "";
      this.ThirdSecEqpId = "";
      this.indexValue.push(2);
    } else if (event.equipmentname == this.FourthEquipmentText) {
      this.EquipDropdownFourthSelected = [];
      this.FourthEquipmentParam = false;
      this.FourthEquipmentText = "";
      this.FourthEqpid = "";
      this.indexValue.push(3);
    }
  }
  GenerateUpdateReport() {
    this.Equipments = [];
    let Fst_id = document.getElementById("fstEq").innerHTML;
    let Sec_id = document.getElementById("secEq").innerHTML;
    let Third_id = document.getElementById("ThirdEq").innerHTML;
    let Fourth_id = document.getElementById("FourthEq").innerHTML;
  
    if (Fst_id != "") {
      this.Equipments.push({
        equipmentID: document.getElementById("fstEq").innerHTML,
        tableColumns: this.addGroupBy(this.EquipDropdownsFirstSelected),
      });
    }
    if (Sec_id != "") {
      this.Equipments.push({
        equipmentID: document.getElementById("secEq").innerHTML,
        tableColumns: this.addGroupBy(this.EquipDropdownSecondSelected),
      });
    }
    if (Third_id != "") {
      this.Equipments.push({
        equipmentID: document.getElementById("ThirdEq").innerHTML,
        tableColumns: this.addGroupBy(this.EquipDropdownThirdSelected),
      });
    }
    if (Fourth_id != "") {
      this.Equipments.push({
        equipmentID: document.getElementById("FourthEq").innerHTML,
        tableColumns: this.addGroupBy(this.EquipDropdownFourthSelected),
      });
    }
    this.RequestJSON1 = {
      ReportID: this.editReportId,
      TimeType: this.editReportTimeType,
      ReportName: this.reportname,
      Equipments: this.Equipments,
    };

    return false;
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.SaveUpdateUrl,
        this.RequestJSON1
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res.body);
          let Success = JSON.parse(getResp);
          Swal.fire(Success);
          this.custmreport.fetchSavedRepoprt();
          this.custmreport.loadDatatoTable();
        },
        (error) => {
          console.error(error);
        }
      );
  }

  addGroupBy(originalArray) {
    let addGroupby = [];
    if (this.reportTypeValue == 1 || this.reportTypeValue == 2) {
      addGroupby.push({
        columnid: "-3",
        groupBy: "0",
      });
    } else {
      addGroupby.push({
        columnid: this.selectedGroupByColumn.toString(),
        groupBy: "1",
      });
    }
    let convertedArray = originalArray.map((item) => ({
      columnid: item.columnid.toString(),
      groupby: "0",
    }));
    const mergedArray = addGroupby.concat(convertedArray);

    return mergedArray;
  }

  DeletSavedReport() {
    this.rowData = this.params;
    Swal.fire({
      title: "Are you sure you want delete this report ",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .get(
            this.urlAuthentication.itocUrl +
              this.apiUrl.DeleteSaved +
              "/" +
              this.rowData.data.ReportID
          )
          .subscribe(
            (res) => {
              const getResp: string = JSON.stringify(res);
              let Success = JSON.parse(getResp);
              this.rowData.data.ReportID = undefined;
              if (Success) {
                Swal.fire({ text: "Report Deleted Sucessfully" });
              } else {
                this.rowData.data.ReportID = undefined;
                Swal.fire({ text: "Failed to Delete" });
              }

              this.custmreport.fetchSavedRepoprt();
              this.custmreport.loadDatatoTable();
            },
            (error) => {
              console.error(error);
            }
          );
      }
    });
  }

  ScheduleRep(event) {
    var target = event.target;
    if (target.checked) {
      this.ScheduleRepAccessability = target.id;
      if (this.ScheduleRepAccessability == "flexRadioDefault1") {
        this.ScheduleRepdailySelectedTypeNum = "1";
      } else if (this.ScheduleRepAccessability == "flexRadioDefault2") {
        this.ScheduleRepdailySelectedTypeNum = "2";
      }
    }
  }
  selectedGroupByColumn;
  LoadEquipmentList() {
    const reqJson = {
      reportType: this.reportTypeValue,
    };
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.getEquipmentListUrl,
        reqJson
      )
      .subscribe(
        (res) => {
          this.EquipDropdown = [];
          this.EquipmentSelected = [];
          this.EquipDropdown = res.response;
          for (let i = 0; i < this.editSelectEquipmentData.length; i++) {
            for (let j = 0; j < this.EquipDropdown.length; j++) {
              if (
                this.EquipDropdown[j].equipmentid ===
                this.editSelectEquipmentData[i].equipmentid
              ) {
                this.EquipmentSelected.push({
                  equipmentid: this.EquipDropdown[j].equipmentid,
                  equipmentname: this.EquipDropdown[j].equipmentname,
                  selectedColumns: this.editSelectEquipmentData[i].columnid,
                });
              }
            }
          }
          this.FirstEquipmentParam = false;
          this.SecondEquipmentParam = false;
          this.ThirdEquipmentParam = false;
          this.FourthEquipmentParam = false;
          this.FirstEquipmentText = "";
          this.SecondEquipmentText = "";
          this.ThirdEquipmentText = "";
          this.FourthEquipmentText = "";
          this.FstEqpId = "";
          this.SecEqpId = "";
          this.FstEqpId = "";
          this.FourthEqpid = "";
          this.EquipmentSelecteds = this.EquipmentSelected;
          if (this.EquipmentSelecteds.length > 0) {
            if (this.EquipmentSelecteds[0].equipmentid != undefined) {
              const selectedColumns =
                this.EquipmentSelecteds[0].selectedColumns.split(",");
              this.selectedGroupByColumn =
                this.EquipmentSelecteds[0].selectedColumns.split(",")[0];

              let dataValue = {
                equipmentId: this.EquipmentSelecteds[0].equipmentid,
                reportType: this.reportTypeValue,
              };
              this.http
                .post(
                  this.urlAuthentication.reportsApi +
                    this.apiUrl.getEquipmentConfigUrl,
                  dataValue
                )
                .subscribe((res) => {
                  let getImgResp = res.response;
                  this.EquipDropdownsFirstSelected = [];
                  this.FirstEquipmentParam = true;
                  this.FirstEquipmentText =
                    this.EquipmentSelecteds[0].equipmentname;
                  this.FstEqpId = this.EquipmentSelecteds[0].equipmentid;

                  this.EquipDropdownsFirst = getImgResp;
                  delete this.indexValue[0];
                  for (let i = 0; i < this.EquipDropdownsFirst.length; i++) {
                    for (let j = 0; j < selectedColumns.length; j++) {
                      if (
                        selectedColumns[j] ==
                        this.EquipDropdownsFirst[i].columnid
                      ) {
                        this.EquipDropdownsFirstSelected.push({
                          columnid: this.EquipDropdownsFirst[i].columnid,
                          fieldaliasname:
                            this.EquipDropdownsFirst[i].fieldaliasname,
                        });
                      }
                    }
                  }
                });
            }
            if (this.EquipmentSelecteds[1].equipmentid != undefined) {
              const selectedColumns =
                this.EquipmentSelecteds[1].selectedColumns.split(",");
              let dataValue = {
                equipmentId: this.EquipmentSelecteds[1].equipmentid,
                reportType: this.reportTypeValue,
              };
              this.http
                .post(
                  this.urlAuthentication.reportsApi +
                    this.apiUrl.getEquipmentConfigUrl,
                  dataValue
                )
                .subscribe((res) => {
                  let getImgResp = res.response;
                  this.EquipDropdownSecondSelected = [];
                  this.SecondEquipmentParam = true;
                  this.SecondEquipmentText =
                    this.EquipmentSelecteds[1].equipmentname;
                  this.SecEqpId = this.EquipmentSelecteds[1].equipmentid;

                  this.EquipDropdownsSecond = getImgResp;
                  delete this.indexValue[1];
                  for (let i = 0; i < this.EquipDropdownsSecond.length; i++) {
                    for (let j = 0; j < selectedColumns.length; j++) {
                      if (
                        selectedColumns[j] ==
                        this.EquipDropdownsSecond[i].columnid
                      ) {
                        this.EquipDropdownSecondSelected.push({
                          columnid: this.EquipDropdownsSecond[i].columnid,
                          fieldaliasname:
                            this.EquipDropdownsSecond[i].fieldaliasname,
                        });
                      }
                    }
                  }
                });
            }
            if (this.EquipmentSelecteds[2].equipmentid != undefined) {
              const selectedColumns =
                this.EquipmentSelecteds[2].selectedColumns.split(",");
              let dataValue = {
                equipmentId: this.EquipmentSelecteds[2].equipmentid,
                reportType: this.reportTypeValue,
              };
              this.http
                .post(
                  this.urlAuthentication.reportsApi +
                    this.apiUrl.getEquipmentConfigUrl,
                  dataValue
                )
                .subscribe((res) => {
                  let getImgResp = res.response;
                  this.EquipDropdownThirdSelected = [];
                  this.ThirdEquipmentParam = true;
                  this.ThirdEquipmentText =
                    this.EquipmentSelecteds[2].equipmentname;
                  this.ThirdSecEqpId = this.EquipmentSelecteds[2].equipmentid;

                  this.EquipDropdownsThird = getImgResp;
                  delete this.indexValue[2];
                  for (let i = 0; i < this.EquipDropdownsThird.length; i++) {
                    for (let j = 0; j < selectedColumns.length; j++) {
                      if (
                        selectedColumns[j] ==
                        this.EquipDropdownsThird[i].columnid
                      ) {
                        this.EquipDropdownThirdSelected.push({
                          columnid: this.EquipDropdownsThird[i].columnid,
                          fieldaliasname:
                            this.EquipDropdownsThird[i].fieldaliasname,
                        });
                      }
                    }
                  }
                });
            }
            if (this.EquipmentSelecteds[3].equipmentid != undefined) {
              const selectedColumns =
                this.EquipmentSelecteds[3].selectedColumns.split(",");
              let dataValue = {
                equipmentId: this.EquipmentSelecteds[3].equipmentid,
                reportType: this.reportTypeValue,
              };
              this.http
                .post(
                  this.urlAuthentication.reportsApi +
                    this.apiUrl.getEquipmentConfigUrl,
                  dataValue
                )
                .subscribe((res) => {
                  let getImgResp = res.response;
                  this.EquipDropdownFourthSelected = [];
                  this.FourthEquipmentParam = true;
                  this.FourthEquipmentText =
                    this.EquipmentSelecteds[3].equipmentname;
                  this.FourthEqpid = this.EquipmentSelecteds[3].equipmentid;

                  this.EquipDropdownsFourth = getImgResp;
                  delete this.indexValue[3];
                  for (let i = 0; i < this.EquipDropdownsFourth.length; i++) {
                    for (let j = 0; j < selectedColumns.length; j++) {
                      if (
                        selectedColumns[j] ==
                        this.EquipDropdownsFourth[i].columnid
                      ) {
                        this.EquipDropdownFourthSelected.push({
                          columnid: this.EquipDropdownsFourth[i].columnid,
                          fieldaliasname:
                            this.EquipDropdownsFourth[i].fieldaliasname,
                        });
                      }
                    }
                  }
                });
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  sampleView(content) {
    this.openConfigureModal(content);
    this.firstArray = [];
    this.SecondArray = [];
    this.ThirddArray = [];
    this.FourthArray = [];
    this.columnDefs = [];
    if (this.EquipDropdownsFirstSelected != undefined) {
      for (let i = 0; i < this.EquipDropdownsFirstSelected.length; i++) {
        this.columnDefs.push({
          headerName: this.EquipDropdownsFirstSelected[i].Name,
          field: this.EquipDropdownsFirstSelected[i].Name,
          width: 180,
          filter: "agTextColumnFilter",
        });
      }
    }
    if (this.EquipDropdownSecondSelected != undefined) {
      for (let i = 0; i < this.EquipDropdownSecondSelected.length; i++) {
        this.columnDefs.push({
          headerName: this.EquipDropdownSecondSelected[i].Name,
          field: this.EquipDropdownSecondSelected[i].Name,
          width: 180,
          filter: "agTextColumnFilter",
        });
      }
    }
    if (this.EquipDropdownThirdSelected != undefined) {
      for (let i = 0; i < this.EquipDropdownThirdSelected.length; i++) {
        this.columnDefs.push({
          headerName: this.EquipDropdownThirdSelected[i].Name,
          field: this.EquipDropdownThirdSelected[i].Name,
          width: 180,
          filter: "agTextColumnFilter",
        });
      }
    }
    if (this.EquipDropdownFourthSelected != undefined) {
      for (let i = 0; i < this.EquipDropdownFourthSelected.length; i++) {
        this.columnDefs.push({
          headerName: this.EquipDropdownFourthSelected[i].Name,
          field: this.EquipDropdownFourthSelected[i].Name,
          width: 180,
          filter: "agTextColumnFilter",
        });
      }
    }
    this.rowDatasample = [];
  }
  /**
   * To open the Export Modal
   * @param content
   */
  openConfigureModal(content) {
    this.modalService.open(content, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  SheduleReportCancel = (evt) => {
    this.isChecked = evt.target.checked;
    if (this.isChecked == true) {
      this.checkedValue = 1;
    } else {
      this.checkedValue = 0;
    }
  };
}
